import { styled } from '@mui/material/styles';

interface InputsWrapperProps {
	firstWidth: string;
	secondWidth: string;
}

export const Form = styled('form')(() => ({
	height: '100%',
}));

export const FormWrapper = styled('div')(() => ({
	display: 'grid',
	gridTemplateColumns: '1fr',
	gridTemplateRows: '1fr max-content',
}));

export const Root = styled('div', {
	shouldForwardProp: (prop) => prop !== 'withPaddings',
})<{ withPaddings: boolean }>(({ withPaddings }) => ({
	padding: withPaddings ? '0 24px' : 0,
	display: 'grid',
	gap: 32,
}));

export const InputsWrapper = styled('div', {
	shouldForwardProp: (prop) => prop !== 'firstWidth' && prop !== 'secondWidth',
})<InputsWrapperProps>(({ firstWidth, secondWidth }) => ({
	display: 'flex',

	'& > div:first-of-type': {
		width: firstWidth,
		marginRight: '16px',
	},

	'& > div:last-of-type': {
		width: secondWidth,
	},
}));

export const DateOfBirthWrapper = styled('div')(() => ({
	display: 'flex',
	alignItems: 'flex-start',
	marginTop: '8px',
	gap: 8,

	'& > div': {
		width: '30%',
	},

	'& > div:last-of-type': {
		width: '40%',
	},
}));

export const DateOfBirthError = styled('span', {
	shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
	display: error ? 'block' : 'none',
	color: theme.palette.error.main,
	...theme.typography.caption,
	marginBottom: '24px',
	marginTop: '-24px',
}));

export const TicketSubtitleWrapper = styled('div')(() => ({
	margin: '8px 0 14px',
}));

export const AccountSubtitleWrapper = styled('div')(() => ({
	margin: '40px 0 12px',
}));

export const SubtitleWrapper = styled('div')(() => ({
	'&:empty': {
		display: 'none',
	},

	marginBottom: 40,
	textAlign: 'center',
}));
